import { z } from "zod";

export const clientAppConfigSchema = z.object({
  autoInviteOnCreate: z.boolean().default(false),
});

export type ClientAppConfig = z.infer<typeof clientAppConfigSchema>;
